import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { sizePerPageList } from "../../../utility";

export const CustomerTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const columns = [
    {
      text: "Customer Code",
      dataField: "customerCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Group 1",
      dataField: "customerGroup1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Group 2",
      dataField: "customerGroup2",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "NPWP",
      dataField: "npwp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Branch Name",
      dataField: "branch_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "City",
      dataField: "city",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   formatter: (cell, row) => (
    //     <div>
    //       <OverlayTrigger
    //         overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
    //       >
    //         <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
    //           <span className="svg-icon svg-icon-md svg-icon-primary">
    //             <SVG
    //               src={toAbsoluteUrl(
    //                 "/media/svg/icons/Communication/Write.svg"
    //               )}
    //             />
    //           </span>
    //         </a>
    //       </OverlayTrigger>
    //     </div>
    //   ),
    // },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="customerId"
      data={data === null ? [] : data}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
    >
      <PleaseWaitMessage entities={loading ? null : data} />
      <NoRecordsFoundMessage entities={loading ? null : data} />
    </BootstrapTable>
  );
};
